export default __webpack_public_path__ + "images/assets/3b417d4ed06b880ea231ccbe80bb8c37.svg";